<div [ngClass]="skeletonClasses" [ngStyle]="skeletonStyles"></div>
